import { gql } from '@/__generated__';
import { DeviceAccessModal_GetAllDeviceAccessForDeviceQuery } from '@/__generated__/graphql';

export type DeviceUserAccessEntry =
  DeviceAccessModal_GetAllDeviceAccessForDeviceQuery['device']['usersWithAccess'][number];

const GET_ALL_DEVICE_ACCESS_FOR_DEVICE = gql(`#graphql
  query DeviceAccessModal_GetAllDeviceAccessForDevice($deviceId: ID!) {
    device(input: { id: $deviceId }) {
      id
      usersWithAccess {
        direct
        visibleToUser
        device {
          id
          visibleToClient
          operationalStateVisibleToClient
          profile {
            id
            operationalState
          }
        }
        user {
          id
          fullName
          email
          mainOrganization {
            organization {
              id
              name
            }
            role {
              id
              name
            }
          }
        }
        collections {
          id
          name
          type
        }
      }
    }
  }
`);

export default GET_ALL_DEVICE_ACCESS_FOR_DEVICE;
